import { useState } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material";
import { Box, Stack } from "@mui/system";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FirstTableAi from "./FirstTableAi/FirstTableAi";
import SecondTableAi from "./SecondTableAi/SecondTableAi";

const StoAirRecomondation = () => {
  // state to track which accordion is expanded
  const [expanded, setExpanded] = useState<string | false>(false);

  const handleChange =
    (panel: string) => (_event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };

  return (
    <Box p={2}>
      {/* Header */}
      <Stack
        direction="column"
        justifyContent="space-between"
        alignItems="left"
        mb={2}
      >
        <Typography variant="h5">Suggestions</Typography>
        <Typography variant="body2" gutterBottom color="text.secondary">
          Identify negative search terms that likely shouldn't be classified as
          such, by recognizing very similar search terms that are already
          defined as “Exclusive” or “Allowed” in other ad groups.
        </Typography>
      </Stack>

      {/* Accordion */}
      {/* Preforming Search Terms Without Classification – 59   */}
      <Accordion
        expanded={expanded === "panel1"}
        onChange={handleChange("panel1")}
        sx={{
          "&.Mui-expanded": {
            margin: 0, // removes extra margin MUI adds to expanded Accordion
          },
          "& .MuiAccordionSummary-root": {
            minHeight: "48px",
          },
          "& .MuiAccordionSummary-root.Mui-expanded": {
            minHeight: "48px",
          },
          "& .MuiAccordionSummary-content": {
            margin: 0,
          },
          "& .MuiAccordionSummary-content.Mui-expanded": {
            margin: 0,
          },
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
          sx={{
            minHeight: "48px !important",
          }}
        >
          <Typography component="span" sx={{ width: "33%", flexShrink: 0 }}>
            Keyword Level – 10
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <FirstTableAi />
        </AccordionDetails>
      </Accordion>
      {/* Exclusive Search Terms Missing Cross-Negatives – 10 */}
      <Accordion
        expanded={expanded === "panel2"}
        onChange={handleChange("panel2")}
        sx={{
          "&.Mui-expanded": {
            margin: 0, // removes extra margin MUI adds to expanded Accordion
          },
          "& .MuiAccordionSummary-root": {
            minHeight: "48px",
          },
          "& .MuiAccordionSummary-root.Mui-expanded": {
            minHeight: "48px",
          },
          "& .MuiAccordionSummary-content": {
            margin: 0,
          },
          "& .MuiAccordionSummary-content.Mui-expanded": {
            margin: 0,
          },
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <Typography component="span" sx={{ width: "33%", flexShrink: 0 }}>
            Search Term Level– 8
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <SecondTableAi />
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};

export default StoAirRecomondation;
